import axios from '../../../config/axiosInstance';

// ─── Types ────────────────────────────────────────────────────────────────────

export type SportDiscipline = 'running' | 'swimming' | 'cycling';

export interface PersonalRecord {
    id: string;
    sport: SportDiscipline;
    distance: string;
    timeValue: string;
    achievedAt: string;
    notes: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface PerformanceTest {
    id: string;
    sport: SportDiscipline;
    testName: string;
    result: string;
    performedAt: string;
    notes: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface CreateRecordInput {
    sport: SportDiscipline;
    distance: string;
    timeValue: string;
    achievedAt: string;
    notes?: string;
}

export interface CreateTestInput {
    sport: SportDiscipline;
    testName: string;
    result: string;
    performedAt: string;
    notes?: string;
}

// ─── Personal Records API ─────────────────────────────────────────────────────

export const getMyRecords = (sport?: SportDiscipline): Promise<PersonalRecord[]> =>
    axios
        .get('/personal-records/me/records', { params: sport ? { sport } : {} })
        .then((r) => r.data);

export const createRecord = (input: CreateRecordInput): Promise<PersonalRecord> =>
    axios.post('/personal-records/me/records', input).then((r) => r.data);

export const updateRecord = (
    id: string,
    input: Partial<Omit<CreateRecordInput, 'sport'>>,
): Promise<PersonalRecord> =>
    axios.patch(`/personal-records/me/records/${id}`, input).then((r) => r.data);

export const deleteRecord = (id: string): Promise<void> =>
    axios.delete(`/personal-records/me/records/${id}`).then(() => undefined);

// ─── Performance Tests API ────────────────────────────────────────────────────

export const getMyTests = (sport?: SportDiscipline): Promise<PerformanceTest[]> =>
    axios
        .get('/personal-records/me/tests', { params: sport ? { sport } : {} })
        .then((r) => r.data);

export const createTest = (input: CreateTestInput): Promise<PerformanceTest> =>
    axios.post('/personal-records/me/tests', input).then((r) => r.data);

export const updateTest = (
    id: string,
    input: Partial<Omit<CreateTestInput, 'sport'>>,
): Promise<PerformanceTest> =>
    axios.patch(`/personal-records/me/tests/${id}`, input).then((r) => r.data);

export const deleteTest = (id: string): Promise<void> =>
    axios.delete(`/personal-records/me/tests/${id}`).then(() => undefined);
